import React from 'react';
import styled from 'styled-components';
const CardWrapper=styled.div`
width: 330px; height: 490px;
background-color: ${({ theme }) => theme.card};
cursor: pointer;
border-radius: 10px;
box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4) ;
overflow:hidden;
padding:26px 20px;
display:flex;
flex-direction:column;
gap:14px;
transition:all 0.5s ease-in-out;
&:hover{
transform:translateY(-10px);
box-shadow: 0 0 50px 4px rgba(0,0,0,0.6);
filter:brightness(1.1);
}
`
const Img=styled.img`
width: 100%; 
height: 180px;
background-color: ${({ theme }) => theme.white}; 
border-radius: 10px;
box-shadow:0 0 16px 2px rgba(0,0,0,0.3);
`
const Tags=styled.div`
display:flex;
width:100%;
align-items:center;
flex-wrap:wrap;
gap:8px;
margin-top:4px;
`
const Details=styled.div`
width: 100%;
display: flex;
flex-direction: column;
gap: 0px;
padding: 0px 2px;`
const Title=styled.div`
font-size: 20px; 
font-weight: 600;
color: ${({ theme }) => theme.text_secondary} ;
overflow: hidden;
display: -webkit-box; 
max-width: 100%;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
`
const Date=styled.div`
font-size: 12px; 
margin-left: 2px; 
font-weight: 400;
color: ${({ theme }) => theme.text_secondary + 80};
@media(max-width: 768px) {
font-size: 10px;}`
const Description=styled.div`
font-weight: 400;
color: ${({ theme }) => theme.text_secondary + 99};
overflow: hidden;  
margin-top: 8px;
display: -webkit-box; max-width: 100%;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;
text-overflow: ellipsis;`
const Button=styled.div`
color: ${({ theme }) => theme.primary}; 
text-decoration: none; 
font-weight: 600; 
text-align: center;
`
const ProjectCard = ({project}) => {
  return (
    <CardWrapper>
      <Img src={project.image}/>
      <Tags>

      </Tags>
   <Details> 
   <Title>
{project.title}
</Title>
<Date>
    {project.date}
</Date>
{/* <Title>{project.title}</Title> */}
<Description>{project.description}</Description>
   </Details>
   <Button href={project.github}>
   View Code
   </Button>
    </CardWrapper>
  )
}

export default ProjectCard
